import React from "react";
import { Typography, FormGroup, FormHelperText } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { graduationTypeOptions } from "../../data";
import { CategoryContainer } from "../../components/CategoryContainer";
import {
  arrToMenuItemOptions,
  RadioGroupRHF,
  SelectRHF,
  DatePickerRHF,
} from "../../components/RHFWrappedComponents";

export function GraduationStatus() {
  const { getValues } = useFormContext();

  return (
    <>
      <CategoryContainer title="Graduation Status">
        <Typography variant="body2">
          The school you are currently enrolled in or have graduated from.
        </Typography>

        <RadioGroupRHF
          name="academicInfo.graduationStatus.graduated"
          groupLabel="Have you graduated?"
          radioGroupOptions={[
            { label: "Yes", value: "true" },
            { label: "No", value: "false" },
          ]}
          row={true}
          rules={{
            validate: {
              requiredIfGraduationTypeSet: (v): boolean | string => {
                const graduationType = getValues(
                  "academicInfo.graduationStatus.graduationType"
                );
                if (graduationType === "") {
                  // Graduation Type not filled in, so any value is okay
                  return true;
                }

                return v === "" ? "Graduation Status must be selected" : true;
              },
            },
          }}
        />

        <SelectRHF
          name="academicInfo.graduationStatus.graduationType"
          selectLabel="Graduation Type"
          menuItemOptions={arrToMenuItemOptions(graduationTypeOptions)}
          rules={{
            validate: {
              requiredIfGraduationSet: (v): boolean | string => {
                const graduated = getValues(
                  "academicInfo.graduationStatus.graduated"
                );
                if (graduated === "") {
                  // Graduated not filled in, so any value is okay
                  return true;
                }

                return v === "" ? "Graduation Type must be selected" : true;
              },
            },
          }}
        />

        <FormGroup>
          <DatePickerRHF
            name="academicInfo.graduationStatus.graduationDate"
            textFieldLabel="Graduation Date"
          />
          <FormHelperText>
            Use expected date for future graduation.
          </FormHelperText>
        </FormGroup>
      </CategoryContainer>
    </>
  );
}
